import React from 'react';

const RondaButton = ({ onClick }) => {
  return (
    <button
      className="fab ronda-button"
      onClick={onClick}
      title="Selecionar Ronda"
      aria-label="Abrir seletor de rondas"
    >
      🚐
    </button>
  );
};

export default RondaButton;

